module.exports = __webpack_public_path__ + "static/media/userIcon.175e1437.svg";